module.exports = __webpack_public_path__ + "img/YEM.14ca363a.svg";